import React from 'react';
import { SafeAreaView } from 'react-native';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import { CodeField, Cursor, useBlurOnFulfill } from 'react-native-confirmation-code-field';
import Text from '../text';
import Colors from '../colors';
import Button from '../button';
import Tooltip from '../tooltip';
import Icon from '../icon';
const StyledCell = styled.Text`
  width: 48;
  height: 56;
  line-height: 50;
  font-size: 18;
  border-width: 1;
  border-color: ${props => props.error ? Colors.error300 : Colors.lightGray400};
  text-align: center;
  background: ${Colors.lightGray100};
  border-radius: 4px;
`;
const StyledResend = styled.View`
  margin: auto;
  padding-top: 16px;
`;
export default function PinInput(props) {
  const {
    value,
    setValue
  } = props;
  const ref = useBlurOnFulfill({
    value,
    cellCount: props.cellCount
  });
  return /*#__PURE__*/React.createElement(SafeAreaView, null, /*#__PURE__*/React.createElement(Tooltip, {
    visible: props.error,
    content: "You entered an incorrect code. Please try again",
    onClose: props.onCloseTooltip,
    renderIcon: () => /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
      name: "warning",
      color: Colors.warning400,
      size: 24
    }),
    showChildInTooltip: false
  }, /*#__PURE__*/React.createElement(CodeField, {
    ref: ref,
    value: value,
    onChangeText: text => {
      props.onChange();
      setValue(text);
    },
    cellCount: props.cellCount,
    textContentType: "oneTimeCode",
    renderCell: _ref => {
      let {
        index,
        symbol,
        isFocused
      } = _ref;
      return /*#__PURE__*/React.createElement(StyledCell, {
        error: props.error,
        key: index
      }, symbol || (isFocused ? /*#__PURE__*/React.createElement(Cursor, null) : null));
    }
  })), /*#__PURE__*/React.createElement(StyledResend, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray400
  }, "Did not receive SMS?", ' ', props.countdown > 0 ? /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray400
  }, "Try again in:", ' ', props.countdown, ' ', "seconds.") : /*#__PURE__*/React.createElement(Button.Text, {
    onPress: props.resend
  }, "Resend"))));
}
PinInput.defaultProps = {
  onChange: () => {},
  onCloseTooltip: () => {},
  error: false,
  cellCount: 6,
  countdown: 0
};
PinInput.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  resend: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onCloseTooltip: PropTypes.func,
  error: PropTypes.bool,
  cellCount: PropTypes.number,
  countdown: PropTypes.number
};
//# sourceMappingURL=pin-input.js.map